import RegistroCaja from '../components/RegistroCaja'

export default function CajaPagosPage() {
  return <RegistroCaja tipo="pago" />
}
